import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { Spacing } from '../../../../enums/spacing'
import { getDefaultTransition } from '../../../../utils/getDefaultTransition'

interface PaymentPaneItemWrapperProps {
  collapsible?: boolean
  withHoverEffect?: boolean
}

export const PaymentPaneItemWrapper = styled.div<PaymentPaneItemWrapperProps>`
  display: grid;
  align-items: center;
  grid-template-columns: minmax(96px, auto) 96px 1fr auto auto;
  width: 100%;
  padding: 20px ${Spacing.S24};
  position: relative;
  ${getDefaultTransition('background-color')}

  ${({ collapsible, withHoverEffect }) => {
    if (!collapsible && withHoverEffect) {
      return css`
        &:hover {
          background-color: ${Color.Grey50};
        }
      `
    }
  }}

  ${({ withHoverEffect }) => {
    if (withHoverEffect) {
      return css`
        cursor: pointer;
      `
    }
  }}

  &:not(&:first-of-type) {
    &:after {
      content: '';
      height: 1px;
      position: absolute;
      top: 0;
      right: ${Spacing.S24};
      left: ${Spacing.S24};
      background-color: ${Color.Grey150};
    }
  }
`

export const PaymentPaneItem = styled.div`
  display: flex;
  padding-right: ${Spacing.S16};

  &:last-of-type {
    padding-right: 0;
  }
`
